export const uischemaBasicIdDetalleEdit = {
  type: "VerticalLayout",
  elements: [
    {
      type: "VerticalLayout",
      elements: [

        {
          type: "Control",
          scope: "#/properties/detalle",
        },
      ],
    },
  ],
};

export const uischemaBasicIdDetalle = {
  type: "VerticalLayout",
  elements: [
    {
      type: "VerticalLayout",
      elements: [
        {
          type: "Control",
          scope: "#/properties/detalle",
        },
      ],
    },
  ],
};
